import { definePreset } from '@openng/optimus-ui-themes';
import Aura from '@openng/optimus-ui-themes/aura';

export const optimusPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: `{blue.50}`,
            100: `{blue.100}`,
            200: `{blue.200}`,
            300: `{blue.300}`,
            400: `{blue.400}`,
            500: `{blue.500}`,
            600: `{blue.600}`,
            700: `{blue.700}`,
            800: `{blue.800}`,
            900: `{blue.900}`,
            950: `{blue.950}`,
        },
        colorScheme: {
            light: {
                primary: {
                    color: '{primary.500}',
                    contrastColor: '#ffffff',
                    hoverColor: '{primary.600}',
                    activeColor: '{primary.700}',
                },
            },
            dark: {
                surface: {
                    50: `{gray.50}`,
                    100: `{gray.100}`,
                    200: `{gray.200}`,
                    300: `{gray.300}`,
                    400: `{gray.400}`,
                    500: `{gray.500}`,
                    600: `{gray.600}`,
                    700: `{gray.700}`,
                    800: `{gray.800}`,
                    900: `{gray.900}`,
                    950: `{gray.950}`,
                },
                primary: {
                    color: '{primary.400}',
                    contrastColor: '{surface.900}',
                    hoverColor: '{primary.300}',
                    activeColor: '{primary.200}',
                },
                formField: {
                    borderColor: '{surface.600}',
                    hoverBorderColor: '{surface.500}',
                },
            },
        },
    },
    components: {
        inputtext: { root: { background: 'transparent' } },
        textarea: { root: { background: 'transparent' } },
        inputnumber: { button: { background: 'transparent' } },
        dropdown: { root: { background: 'transparent' } },
        multiselect: { root: { background: 'transparent' } },
        select: { root: { background: 'transparent' } },
        autocomplete: { root: { background: 'transparent' } },
        listbox: { root: { background: 'transparent' } },
        checkbox: { root: { background: 'transparent' } },
        tooltip: {
            root: {
                maxWidth: '35rem',
                padding: '0.1rem 0.5rem',
                gutter: '0.5rem',
            },
        },
    },
});
